import { ObjectValues } from "@/src/shared/types/objectValues";

export const DS_USER_STATUS = {
  None: "none",
  Online: "online",
  Offline: "offline",
  Away: "away",
  DoNotDisturb: "dnd",
} as const;

export type DSUserStatus = ObjectValues<typeof DS_USER_STATUS>;
